import { render, staticRenderFns } from "./InformacoesRestricao.vue?vue&type=template&id=74331f36&lang=pug"
import script from "./InformacoesRestricao.vue?vue&type=script&lang=js"
export * from "./InformacoesRestricao.vue?vue&type=script&lang=js"
import style0 from "./InformacoesRestricao.vue?vue&type=style&index=0&id=74331f36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports